var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
import { getEffectivePriceEUR } from '../utils/promo';
var CartContext = createContext(undefined);
export var useCart = function () {
    var context = useContext(CartContext);
    if (!context) {
        throw new Error('useCart must be used within a CartProvider');
    }
    return context;
};
// Cookie helper functions
var CART_COOKIE_NAME = 'kamea_cart';
var CART_COOKIE_DAYS = 7; // Cart persists for 7 days
var isClient = typeof document !== 'undefined';
var getCookie = function (name) {
    if (!isClient)
        return null;
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
};
var setCookie = function (name, value, days) {
    if (!isClient)
        return;
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
};
var deleteCookie = function (name) {
    if (!isClient)
        return;
    document.cookie = name + '=; Max-Age=-99999999; path=/';
};
var loadCartFromCookie = function () {
    try {
        var cartCookie = getCookie(CART_COOKIE_NAME);
        if (cartCookie) {
            return JSON.parse(decodeURIComponent(cartCookie));
        }
    }
    catch (error) {
        console.error('Error loading cart from cookie:', error);
    }
    return [];
};
var saveCartToCookie = function (items) {
    try {
        var cartString = encodeURIComponent(JSON.stringify(items));
        setCookie(CART_COOKIE_NAME, cartString, CART_COOKIE_DAYS);
    }
    catch (error) {
        console.error('Error saving cart to cookie:', error);
    }
};
export var CartProvider = function (_a) {
    var children = _a.children;
    var _b = useState(function () { return loadCartFromCookie(); }), items = _b[0], setItems = _b[1];
    var _c = useState(false), isCartOpen = _c[0], setIsCartOpen = _c[1];
    // Save cart to cookie whenever items change
    useEffect(function () {
        saveCartToCookie(items);
    }, [items]);
    // Listen for storage events to sync cart across tabs
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var handleStorageChange = function (e) {
            if (e.key === 'kamea_cart_sync') {
                setItems(loadCartFromCookie());
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return function () {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);
    // Trigger sync across tabs when cart changes
    var syncCartAcrossTabs = function () {
        if (typeof window === 'undefined')
            return;
        try {
            localStorage.setItem('kamea_cart_sync', Date.now().toString());
            localStorage.removeItem('kamea_cart_sync');
        }
        catch (error) {
            console.error('Error syncing cart across tabs:', error);
        }
    };
    var addItem = function (product) {
        setItems(function (prevItems) {
            var existingItem = prevItems.find(function (item) { return item.id === product.id; });
            if (existingItem) {
                return prevItems.map(function (item) {
                    return item.id === product.id
                        ? __assign(__assign({}, item), { quantity: item.quantity + 1 }) : item;
                });
            }
            return __spreadArray(__spreadArray([], prevItems, true), [__assign(__assign({}, product), { quantity: 1 })], false);
        });
        syncCartAcrossTabs();
        setIsCartOpen(true);
    };
    var removeItem = function (productId) {
        setItems(function (prevItems) { return prevItems.filter(function (item) { return item.id !== productId; }); });
        syncCartAcrossTabs();
    };
    var updateQuantity = function (productId, quantity) {
        if (quantity <= 0) {
            removeItem(productId);
            return;
        }
        setItems(function (prevItems) {
            return prevItems.map(function (item) {
                return item.id === productId ? __assign(__assign({}, item), { quantity: quantity }) : item;
            });
        });
        syncCartAcrossTabs();
    };
    var clearCart = function () {
        setItems([]);
        syncCartAcrossTabs();
        deleteCookie(CART_COOKIE_NAME);
    };
    // The cart cookie holds a snapshot of each product from when it was added,
    // so pull the current price/promo before showing totals.
    var refreshPrices = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, products_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, fetch('/api/products')];
                case 1:
                    response = _a.sent();
                    if (!response.ok)
                        return [2 /*return*/];
                    return [4 /*yield*/, response.json()];
                case 2:
                    products_1 = _a.sent();
                    setItems(function (prevItems) {
                        return prevItems.map(function (item) {
                            var latest = products_1.find(function (p) { return p.id === item.id; });
                            if (!latest)
                                return item;
                            return __assign(__assign({}, item), { priceEUR: latest.priceEUR, promoPriceEUR: latest.promoPriceEUR, promoEndsAt: latest.promoEndsAt });
                        });
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Error refreshing cart prices:', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (isCartOpen && items.length > 0) {
            refreshPrices();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCartOpen]);
    var openCart = function () {
        setIsCartOpen(true);
    };
    var closeCart = function () {
        setIsCartOpen(false);
    };
    var totalItems = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var totalPriceEur = Math.round(items.reduce(function (sum, item) { return sum + getEffectivePriceEUR(item) * item.quantity; }, 0) * 100) / 100;
    var totalRegularEur = items.reduce(function (sum, item) { return sum + item.priceEUR * item.quantity; }, 0);
    var totalSavingsEur = Math.round((totalRegularEur - totalPriceEur) * 100) / 100;
    return (_jsx(CartContext.Provider, { value: {
            items: items,
            addItem: addItem,
            removeItem: removeItem,
            updateQuantity: updateQuantity,
            clearCart: clearCart,
            totalItems: totalItems,
            totalPriceEur: totalPriceEur,
            totalSavingsEur: totalSavingsEur,
            refreshPrices: refreshPrices,
            isCartOpen: isCartOpen,
            openCart: openCart,
            closeCart: closeCart,
        }, children: children }));
};
